<template>
  <div>
    <v-container fluid>
      <loading-component
        :value="loading || !eventsAreLoaded"
      ></loading-component>
      <v-layout align-center justify-space-between row fill-height>
        <v-flex md2 sm12>
          <!-- <v-label> Shift </v-label> -->
          <choose-date clearable :label="$t('messagingPage.from')" v-model="start"></choose-date>
        </v-flex>
        <v-flex md2 sm12>
          <!-- <v-label> Shift </v-label> -->
          <choose-date clearable :label="$t('messagingPage.to')" v-model="end"></choose-date>
        </v-flex>
        <v-flex md2 sm12>
                  <v-select
                    item-text="Event Type"
                    :items="['All', 'Normal', 'Seasonal', 'Mix']"
                    v-model="event_type"
                    :label="$t('messagingPage.eventType')"
                  ></v-select>
                </v-flex>
        <v-flex md2 sm12>
          <v-btn
            v-if="this.start != null && this.end != null"
            dark
            class="mb-2 cbtn"
            @click="getData(false)"
            :loading="buttonLoading"
            color="secondary"
            >{{ $t('messagingPage.get') }}</v-btn
          >
        </v-flex>
        <v-btn
          color="primary"
          dark
          class="mb-2 cbtn"
          @click="exportCSV"
          :loading="loading"
          >{{ $t('messagingPage.exportCSV') }}</v-btn
        >
      </v-layout>
    </v-container>
    <div class="main-container" v-if="eventsAreLoaded">
      <div class="scroll">
        <div class="card" v-for="(item, index) in data" :key="index">
          <div class="name">
            <h2>
              {{ $t('messagingPage.eventRange', { type: item.type, start: moment(item.start_date).format("DD-MM-YYYY"), end: moment(item.end_date).format("DD-MM-YYYY") }) }}
            </h2>
          </div>
          <div class="days">
            <div class="day">
              <!-- <div class="day-name white-bg"><span>Weekend number</span></div> -->
              <div class="day-name white-bg"><span>{{ $t('messagingPage.weekdayAndDate') }}</span></div>
              <div class="shifts white-bg">
                <div class="shift white-bg">
                  <div class="time white-bg">{{ $t('messagingPage.shift') }}</div>
                  <div class="count white-bg">{{ $t('messagingPage.completedOrders') }}</div>
                  <!-- <div class="count"># Signed drivers</div> -->
                  <div class="taxi-numbers white-bg" style="padding-top: 12px">
                    {{ $t('messagingPage.registeredDrivers') }}
                  </div>
                  <div class="taxi-numbers white-bg" style="padding-top: 12px">
                    {{ $t('messagingPage.missingDrivers') }}
                  </div>
                  <div class="taxi-numbers white-bg" style="padding-top: 12px">
                    {{ $t('messagingPage.activeDrivers') }}
                  </div>
                  <div class="taxi-numbers white-bg" style="padding-top: 12px">
                    {{ $t('messagingPage.extraDrivers') }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="day"
              v-for="(data, index) in item.days"
              :key="index"
            >
              <!-- <div class="day-name"> -->
                <!-- <span>Weekend {{ data[0].shift_weekend_number }}</span> -->
              <!-- </div> -->
              <div class="day-name">
                <span>{{ moment(data.day).format("DD.MM.YYYY") }}</span>
              </div>
              <div class="shifts">
                <div
                  class="shift"
                  v-for="(shift, shiftIndex) in data.daily_shifts"
                  :key="shiftIndex"
                >
                  <div class="time">{{ formatShiftDate(shift.from, shift.to) }}</div>
                  <div class="count">{{ shift.completedOrders }}</div>
                  <!-- <div class="count">{{ shift.registeredCaptainsUsername.length }}</div> -->
                  <div class="taxi-numbers" :style="'color: ' + shift.registeredCaptainsColor + ';'">
                    <expansion-panel :content="shift.registeredCaptainsUsername"></expansion-panel>
                  </div>
                  <div class="taxi-numbers" :style="'color: ' + shift.missingCaptainsColor + ';'">
                    <expansion-panel :content="shift.missingCaptainsUsername"></expansion-panel>
                  </div>
                  <div class="taxi-numbers" :style="'color: ' + shift.activeCaptainsColor + ';'">
                    <expansion-panel :content="shift.activeCaptainsUsername"></expansion-panel>
                  </div>
                  <div class="taxi-numbers" :style="'color: ' + shift.extraColor + ';'">
                    <expansion-panel :content="shift.extraDrivers"></expansion-panel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="diaload" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('messagingPage.savingChanges') }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ChooseCaptainsMulti from "@/components/monaco/input/ChooseCaptainMulti";
import LoadingComponent from "@/components/LoadingComponent";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import ConfirmDialog from "@/components/monaco/ConfirmDialog";
import ExpansionPanel from '@/components/ExpansionPanel';
import moment from "moment";
import { companyNow } from "@/util/companyTime";
export default {
  name: "EventReports",
  title() {
    return this.$t("messagingPage.eventsPageTitle");
  },
  components: {
    ConfirmDialog,
    ChooseDate,
    LoadingComponent,
    ChooseCaptainsMulti,
    ExpansionPanel,
  },
  data() {
    return {
      event_type: "All",
      data: {},
      loading: false,
      buttonLoading: false,
      search: "",
      items: [],
      start: "",
      end: "",
      menu: false,
      diaload: false,
      eventsAreLoaded: false,
      months: [],
      selectedMonth: null,
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    selectedMonth(val) {
      this.start = moment(val).startOf("month").format("YYYY-MM-DD");
      this.end = moment(val).endOf("month").format("YYYY-MM-DD");
      this.getData(false);
    },
  },
  mounted() {
    // this.start = moment().startOf("month").format("YYYY-MM-DD HH:mm:ss");
    // this.end = moment().endOf("month").format("YYYY-MM-DD HH:mm:ss");
    this.getMonths();
    this.getData();
  },
  methods: {
    formatShiftDate(from, to){
      const [hoursFrom, minutesFrom] = from.split(':');
      const formattedFrom = `${hoursFrom}:${minutesFrom}`;
      const [hoursTo, minutesTo] = to.split(':');
      const formattedTo = `${hoursTo}:${minutesTo}`;
      return `${formattedFrom} - ${formattedTo}`;
    },
    formatDateTime(time) {
      return moment(time).format("HH[h]m - DD[/]MM[/]YYYY");
    },
    test() {
      console.log("test");
    },
    // exportCSV() {
    //   console.log("exported");
    // },
    getMonths() {
      this.start = companyNow().startOf("month").format("YYYY-MM-DD");
      this.end = companyNow().endOf("month").format("YYYY-MM-DD");
      // this.axios.get("get_events_months").then((res) => {
      //   console.log(res);
      //   let arr = [];
      //   res.data.forEach((item) => {
      //     arr.push({
      //       value: moment(item, "MMMM YYYY").format("YYYY-MM-DD hh:mm:ss"),
      //       text: item,
      //     });
      //   });
      //   this.months = arr;
      // });
    },
    exportCSV() {
      this.loading = true;
      let flags = {};
      flags["export"] = true;
      flags["from"] = this.start;
      flags["to"] = this.end;
      flags["event_type"] = this.event_type;
      this.axios
        .get("get_events_report", {
          params: {
            ...flags,
          },
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          var now = moment(this.start).format("MMMM-YYYY");
          var name = this.start ? now : "";
          link.setAttribute("download", name + "Data Report.csv");
          document.body.appendChild(link);
          link.click();
          window.getApp.$emit("SHOW_TOAST", this.$t("messagingPage.success"), "green");
        })
        .catch(({ response }) =>
          window.getApp.$emit("SHOW_TOAST", this.$t("messagingPage.downloadFailed"), "red")
        )
        .finally(() => (this.loading = false));
    },
    getData(csv) {
      this.buttonLoading = true;
      this.eventsAreLoaded = false;
      // this.data = [];
      let flags = {};
      if (csv) flags["export"] = true;
      flags["from"] = this.start;
      flags["to"] = this.end;
      flags["event_type"] = this.event_type;
      this.axios
        .get("get_events_report", {
          params: {
            ...flags,
          },
        })
        .then((res) => {
          console.log("DATA");
          console.log(res.data);
          this.data = res.data;
          // let arr = res.data;
          // for (let i = 0; i < arr.length; i++) {
          //   if (!(arr[i].name in this.data)) {
          //     this.data[arr[i].name] = {};
          //     this.data[arr[i].name]["draft"] = [arr[i]];
          //   } else {
          //     this.data[arr[i].name]["draft"].push(arr[i]);
          //   }
          // }
          // Object.keys(this.data).forEach((key) => {
          //   this.data[key].draft.forEach((item) => {
          //     if (item.registered_captains)
          //       item.registered_captains = item.registered_captains.split(",");

          //     if (item.completed_captains[0])
          //       item.completed_captains = item.completed_captains[0].split(",");
          //     else item.completed_captains = null;

          //     if (item.non_completed_captains.length > 0)
          //       item.non_completed_captains = item.non_completed_captains;
          //     else item.non_completed_captains = null;

          //     item.formatted_shift =
          //       moment(item.start_date).format("HH[h]mm") +
          //       " - " +
          //       moment(item.end_date).format("HH[h]mm");

          //     if (!(item.shift_day in this.data[key])) {
          //       this.data[key][item.shift_day] = [item];
          //     } else {
          //       this.data[key][item.shift_day].push(item);
          //     }
          //   });
          //   delete this.data[key]["draft"];
          // });
          this.buttonLoading = false;
        })
        .catch((err) => {
          this.buttonLoading = false;
        })
        .finally(() => {
          this.buttonLoading = false;
          this.eventsAreLoaded = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.constraint {
  border: 1px;
  border-style: solid;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 1px 1px;
  width: max-content;
  align-items: center;
  display: flex;
  margin-inline-end: 10px;
  margin-bottom: 15px;
}
.name {
  margin-inline-start: 5px;
}
.test {
  color: red;
}

.main-container {
  float: inline-start;
  width: 100%;
  height: auto;

  .scroll {
    float: inline-start;
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 180px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 28px;
    justify-content: flex-start;
    padding: 12px;

    .card {
      width: 100%;
      border-radius: 12px;
      float: inline-start;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
      height: auto;
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      // flex-wrap: nowrap;
      flex-direction: row;

      .name {
        min-height: 180px;
        float: inline-start;
        flex-grow: 0;
        flex-shrink: 1;
        padding: 18px 24px;
        border-inline-end: 2px solid #eee;
        position: relative;

        h2 {
          float: inline-start;
          font-weight: 400;
          margin: 0;
          writing-mode: vertical-lr;
          text-orientation: sideways;
          transform: rotate(180deg);
          position: sticky;
          top: 18px;
        }
      }
      .days {
        flex-grow: 1;
        flex-shrink: 1;
        float: inline-start;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        position: relative;

        .day {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: stretch;
          flex-direction: row;
          flex-shrink: 1;
          flex-grow: 0;

          &:first-child {
            border-start-end-radius: 12px;
            top: -12px;
            z-index: 2;
            background: white !important;
            position: sticky;
            .day-name {
              display: flex;
              justify-content: center;
              align-items: center;
              span {
                position: static;
              }
            }
          }

          &:last-child {
            border-end-end-radius: 12px;
          }

          &:nth-child(odd) {
            background: white;
            .shifts {
              .shift {
                &:nth-child(odd) {
                  background-color: white;
                }

                &:not(:nth-child(odd)) {
                  background-color: #f8f8f8;
                }
              }
            }
          }

          &:nth-child(even) {
            background: #f2f2f2;
            .shifts {
              .shift {
                &:nth-child(odd) {
                  background-color: #f2f2f2;
                }

                &:not(:nth-child(odd)) {
                  background-color: #f8f8f8;
                }
              }
            }
          }

          &:not(:last-child) {
            border-bottom: 2px solid #c2c2c2;
          }

          .day-name {
            width: 120px;
            float: inline-start;
            padding: 12px;
            border-inline-end: 2px solid #e1e1e1;
            flex-grow: 0;
            flex-shrink: 0;
            position: relative;

            span {
              position: sticky;
              top: 108px;
              font-size: 12pt;
            }
          }

          .shifts {
            flex-direction: column;
            display: flex;
            align-items: stretch;
            justify-content: flex-start;
            height: 100%;
            flex-grow: 1;

            .shift {
              flex-grow: 0;
              flex-shrink: 0;
              display: flex;
              justify-content: flex-start;
              align-items: stretch;
              flex-flow: row;

              &:first-child {
                border-start-end-radius: 12px;
              }

              .time{
                font-size: 12pt;
                width: 150px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-grow: 0;
                flex-shrink: 0;
                float: inline-start;
                padding: 12px;
                border-inline-end: 2px solid #e1e1e1;
              }
              .count {
                font-size: 12pt;
                width: 80px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-grow: 0;
                flex-shrink: 0;
                float: inline-start;
                padding: 12px;
                border-inline-end: 2px solid #e1e1e1;
              }

              .count {
                width: 140px;
                // word-break: break-all;
              }

              .taxi-numbers {
                // padding: 12px;
                // padding-top: 60px;
                display: flex;
                flex-basis: 0;
                flex-grow: 1;
                justify-content: center;
                // align-items: center;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 4px;
                font-size: 12pt;
                word-break: break-all;
                position: relative;

                &:not(:last-child) {
                  border-inline-end: 2px solid #e1e1e1;
                }

                .number {
                  padding: 8px 18px;
                  width: max-content;
                  background: #f7f8fa;
                  border: 1px solid #5f6777;
                  font-size: 10pt;
                  border-radius: 99px;
                  max-height: 36px;

                  &.total-count {
                    position: absolute;
                    border: 2px solid #5f6777;
                    font-weight: 600;
                    top: 12px;
                    left: 50%;
                    transform: translateX(-50%);
                  }

                  &.red {
                    background: #f7f8fa !important;
                    border: 1px solid #27a432;
                    color: #27a432;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.white-bg {
  background: white !important;
}
</style>
